import { budgetsStateSelector } from "@/store/budgets/selectors/budgetsStateSelector";
import { RootState } from "@/store/store";

export const budgetDetailsDrawerAccumulatedCostDateSelector = (
  state: RootState,
) => {
  return budgetsStateSelector(state).detailsDrawer.accumulatedCostDate;
};
